export const refs = {
  form: document.querySelector('.header-form'),
  list: document.querySelector('.tasks-list'),
  changeThemeBtn: document.querySelector('.theme-toggle-button'),
};
